// extracted by mini-css-extract-plugin
export default {"residentPage__buttons":"ResidentsPage_residentPage__buttons__DC-1t","residentPage__buttonActive":"ResidentsPage_residentPage__buttonActive__76Wga"};